import styled from "styled-components";

export const SeparateLineTop = styled.div `
    border-top: 1px solid ${props => props.theme.colors.neutral1.pure};
`

export const SeparateLineBottom = styled.div `
    border-bottom: 1px solid ${props => props.theme.colors.neutral1.pure};
    
`